export default {
    GET_NOTIFICATION_DATA: "GET_NOTIFICATION_DATA"
}